import cc from "classcat";

const Title = ({ level = "h2", className = "mb-2", children, ...props }) => {
  const Component = level;

  return (
    <Component
      className={cc([
        "h1",
        {
          "text-center": !className.match(
            /text-(?:[sxmlgd]{2}-)?(?:left|right|center)/
          ),
        },
        className,
      ])}
      {...props}
    >
      {children}
    </Component>
  );
};

export default Title;
